import React from "react";
import { Container, Grid, Link } from "@material-ui/core";
import styled from "@emotion/styled";
import Phone from "../../img/phone.png";

const DesktopMenu = (props) => {

    const Button = styled.button`
    border:none;
    height: 43px;
    color: #ffffff !important;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
    line-height: 35px;
    background-color: #B82E3C;
      &:focus{
        outline: none;
      }
    `
  const menulist = props.menuList.map(function (value, i) {
    return (
      <Link href={value[1]} className="px-4" style={{ color: "#ffffff" }}>
        {value[0]}
      </Link>
    );
  });
  return (
    <Container maxWidth="lg">
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        className="py-4"
      >
        <Grid xs={12} sm={2}>
          <Link href="/" className="d-inline-block">
            <img src={props.siteLogo} className="img-fluid w-100" />
          </Link>
        </Grid>
        <Grid xs={12} sm={10} className="text-right">
          {menulist}
          <Button>
          <a class="px-2">
          <img src={Phone} className="img-fluid" />+92 51 220 3122
          </a>
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DesktopMenu;
